// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-2303467c] {\n  width:100%;\n}[dir=ltr] div[data-v-2303467c] {\n  text-align: right;\n}[dir=rtl] div[data-v-2303467c] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
